module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card-prospect dashboard-card dashboard-card--bordered dashboard-card--hoverable"
  }, [_c('header', {
    staticClass: "dashboard-card__header"
  }, [_c('img', {
    staticClass: "dashboard-card__icon",
    attrs: {
      "src": _vm.imgUser,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dashboard-card__header-info"
  }, [_c('h4', {
    staticClass: "dashboard-card__name"
  }, [_vm._v(_vm._s(_vm.user.fullName))]), _vm._v(" "), _c('span', {
    staticClass: "dashboard-status dashboard-status--prospect"
  }, [_vm._v("Prospect")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.user.id
        }
      }
    }
  }, [_c('svg', {
    staticClass: "dashboard-card__arrow",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])], 1), _vm._v(" "), _c('section', {
    staticClass: "dashboard-card__contact"
  }, [_c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("mailto:" + (_vm.user.email))
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgMail,
      "alt": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.user.email) + "\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "dashboard-card__contact-link",
    attrs: {
      "href": ("tel:" + (_vm.user.phone))
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPhone,
      "alt": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.user.phone) + "\n                ")])]), _vm._v(" "), _c('footer', {
    staticClass: "dashboard-card__footer"
  }, [(_vm.user.colonne === 'col_pp') ? _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgTime,
      "alt": ""
    }
  }), _vm._v("\n                    Paysage : "), _c('span', {
    staticClass: "dashboard-badge",
    class: _vm.statusPaysageClass
  }, [_vm._v(_vm._s(_vm.statusPaysage))])]) : _vm._e(), _vm._v(" "), (_vm.user.colonne === 'col_conseil') ? _c('div', {
    staticClass: "card-prospect__mission"
  }, [_c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgDoc,
      "alt": ""
    }
  }), _vm._v("\n                        Lettre de mission : "), _c('span', {
    staticClass: "dashboard-badge",
    class: _vm.lettreMissionClass
  }, [_vm._v(_vm._s(_vm.lettreMissionStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgDoc,
      "alt": ""
    }
  }), _vm._v("\n                        Rapport de mission "), _c('span', {
    staticClass: "dashboard-badge",
    class: _vm.rapportMissionClass
  }, [_vm._v(_vm._s(_vm.rapportMissionStatus))])])]) : _vm._e(), _vm._v(" "), (_vm.user.colonne === 'col_inscription_partenaire') ? _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('label', {
    staticClass: "card-prospect__toggle"
  }, [_c('span', {
    staticClass: "card-prospect__toggle-track",
    class: {
      'card-prospect__toggle-track--active': _vm.user.partenaire_incription
    }
  }, [_c('span', {
    staticClass: "card-prospect__toggle-thumb"
  })]), _vm._v(" "), _c('input', {
    staticClass: "card-prospect__toggle-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.user.partenaire_incription
    },
    on: {
      "change": function($event) {
        return _vm.$emit('toggle-inscrit-partenaire', _vm.user.id, $event.target.checked)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "card-prospect__toggle-label"
  }, [_vm._v("Inscrit dans la base partenaire")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashboard-info-row"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgCalendar,
      "alt": ""
    }
  }), _vm._v("\n                    Créé il y a environ " + _vm._s(_vm.daysSinceCreation)), (_vm.creationDate) ? [_vm._v(" (le " + _vm._s(_vm.creationDate) + ")")] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb9c049e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/CardProspect.vue
// module id = 1185
// module chunks = 0